import { call } from './utils';

//**** STATION CRUD
export const createFile = async (data, accessToken) =>
  await call({
    url: '/api/file/create',
    data: { data },
    token: accessToken
  });
export const updateFile = async (data, accessToken) =>
  await call({
    url: '/api/file/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeFile = async (data, accessToken) =>
  await call({
    url: '/api/file/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllFiles = async (data, accessToken) =>
  await call({
    url: '/api/file/find/all',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findFileById = async (data, accessToken) =>
  await call({
    url: '/api/file/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const addResourceToServer = async (data, accessToken) =>
  await call({
    url: '/api/file/add/resources/to/server',
    data: data,
    method: 'POST'
  });
export const getResourceFromServer = async (data, accessToken) =>
  await call({
    url: '/api/file/get/resources/from/server',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
